import { useState } from "react";
import { Package, Phone, Menu, X } from "lucide-react";
import { Button } from "@/components/ui/button";

export const Navbar = ({ onOpenForm, onOpenContact }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    setIsMenuOpen(false);
  };

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm border-b border-gray-100">
      <div className="container-custom flex items-center justify-between h-16 md:h-20">
        <a href="/" className="flex items-center gap-2" data-testid="nav-logo">
          <div className="w-10 h-10 bg-[#0F5132] rounded-lg flex items-center justify-center">
            <Package className="w-6 h-6 text-white" />
          </div>
          <span className="font-bold text-lg text-[#1F2937] hidden sm:block" style={{ fontFamily: "Manrope" }}>
            CashForTestStripsJax
          </span>
        </a>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-6">
          <button onClick={() => scrollToSection("how-it-works")} className="text-[#4B5563] hover:text-[#0F5132] font-medium transition-colors" data-testid="nav-how-it-works">
            How It Works
          </button>
          <button onClick={() => scrollToSection("requirements")} className="text-[#4B5563] hover:text-[#0F5132] font-medium transition-colors" data-testid="nav-requirements">
            Requirements
          </button>
          <button onClick={() => scrollToSection("faq")} className="text-[#4B5563] hover:text-[#0F5132] font-medium transition-colors" data-testid="nav-faq">
            FAQ
          </button>
          <button
            onClick={onOpenContact}
            className="flex items-center gap-2 text-[#0F5132] hover:text-[#0B3D25] font-semibold transition-colors border-l border-gray-200 pl-6"
            data-testid="nav-phone-btn"
          >
            <Phone className="w-4 h-4" />
            <span>(904) 955-9646</span>
          </button>
          <Button
            onClick={onOpenForm}
            className="bg-[#EA580C] hover:bg-[#C2410C] text-white rounded-full px-6 font-semibold"
            data-testid="nav-sell-btn"
          >
            Get Your Offer
          </Button>
        </div>

        {/* Mobile Menu Button */}
        <button className="md:hidden p-2" onClick={() => setIsMenuOpen(!isMenuOpen)} data-testid="mobile-menu-btn">
          {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && (
        <div className="md:hidden bg-white border-t border-gray-100 py-4">
          <div className="container-custom flex flex-col gap-4">
            <button
              onClick={() => { onOpenContact(); setIsMenuOpen(false); }}
              className="flex items-center justify-center gap-2 py-3 bg-[#0F5132] text-white rounded-full font-semibold"
              data-testid="mobile-contact-btn"
            >
              <Phone className="w-4 h-4" />
              <span>(904) 955-9646</span>
            </button>
            <button onClick={() => scrollToSection("how-it-works")} className="text-left py-2 text-[#4B5563] font-medium">
              How It Works
            </button>
            <button onClick={() => scrollToSection("requirements")} className="text-left py-2 text-[#4B5563] font-medium">
              Requirements
            </button>
            <button onClick={() => scrollToSection("faq")} className="text-left py-2 text-[#4B5563] font-medium">
              FAQ
            </button>
            <Button
              onClick={() => { onOpenForm(); setIsMenuOpen(false); }}
              className="bg-[#EA580C] hover:bg-[#C2410C] text-white rounded-full font-semibold w-full"
              data-testid="mobile-sell-btn"
            >
              Get Your Offer
            </Button>
          </div>
        </div>
      )}
    </nav>
  );
};
